export default __webpack_public_path__ + "static/2-login-8b335af2b50ec6809e87002066b4bb39.png";